module.exports = "<div class=\"share\" v-if=\"isActive\">\n    <a class=\"share__btn noselect\">\n        <icon class=\"share__icon\" />\n        <span class=\"share__label\">{{label}}</span>\n    </a>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./assets/_js/components/share/share.vhtml
// module id = 318
// module chunks = 0